<template>
  <div class="container">
    <div class="text-end p-3">
      <c-primary-button to="/admin/configuraciones/aspectos/crear">
        Crear aspecto
      </c-primary-button>
    </div>
    <c-card title="Aspectos">
      <table class="table table-striped">
        <thead>
          <tr>
            <th>Aspecto</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="aspecto in aspectos" :key="aspecto.id">
            <td>{{ aspecto.name }}</td>
            <td class="text-nowrap">
              <router-link
                class="btn btn-secondary btn-sm ms-2 d-inline-block"
                :to="`/admin/configuraciones/aspectos/${aspecto.id}/editar`"
                title="Editar"
                ><i class="fa-solid fa-pen"></i
              ></router-link>
              <a
                class="btn btn-secondary btn-sm ms-2 d-inline-block"
                href="javascript:void(0)"
                @click="deleteAspecto(aspecto.id)"
                title="Eliminar"
                ><i class="fa-solid fa-trash-can"></i
              ></a>
            </td>
          </tr>
        </tbody>
      </table>
    </c-card>
  </div>
</template>
<script>
import CCard from "@/components/CCard.vue";
import CPrimaryButton from "@/components/CPrimaryButton.vue";
import { all, remove } from "@/services/aspectos";
import { showNotification } from "@/services/notification";

export default {
  components: {
    CCard,
    CPrimaryButton,
  },
  data() {
    return {
      aspectos: [],
    };
  },
  mounted() {
    this.getAspectos();
  },
  methods: {
    getAspectos() {
      all()
        .then((response) => {
          this.aspectos = response.data;
        })
        .catch(() => {
          alert("No pudimos cargar los aspectos");
        });
    },
    deleteAspecto(id) {
      const removeRecord = confirm("¿Estás seguro de eliminar el registro?");
      if (!removeRecord) {
        return;
      }
      remove(id).then(() => {
        showNotification(204, "success", "El registro fue eliminado.");
        this.getAspectos();
      });
    },
  },
};
</script>
